export default __webpack_public_path__ + "static/media/por_que_movil_1.dc92c547.svg";